"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prettify = void 0;
const types_1 = require("../../types");
const style_1 = require("../../style");
const code_1 = require("../../code");
function prettify(context) {
    const { dataPath, error: { keyword, params: { limit } } } = types_1.getTypedContext(context);
    const [prePath, pathExpr, postPath] = style_1.pathDescription(context, 'string');
    const limitOperation = keyword === 'maxLength'
        ? style_1.style.expr('at most', context)
        : keyword === 'minLength'
            ? style_1.style.expr('at least', context)
            : '{unknown}';
    const validStatement = `${limitOperation} ` +
        style_1.style.number(`${limit}`, context) +
        style_1.style.expr(' characters long', context);
    const title = style_1.style.title(`The ${prePath}`, context) +
        pathExpr +
        style_1.style.title(`${postPath} should be `, context) +
        validStatement;
    const codeFrame = code_1.printCode('Ensure this is ' + validStatement, context.parsedJson, { dataPath: dataPath.dotOnly, markIdentifier: false });
    return { title, codeFrame };
}
exports.prettify = prettify;
